module.exports = __webpack_public_path__ + "static/media/ips.900284b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/ips.png
// module id = 397
// module chunks = 0